import { useState } from 'react';
import { useBulkActionsState } from 'src/components/common/BulkActions/useBulkActionsState';
import { useSalesBulkActionsState } from 'src/components/Sales/BulkActions/useSalesBulkActionsState';
import { useBulkDeallocateCancelSalesAction } from 'src/components/Sales/SalesActionDropdown/components/BulkDeallocateCancelSalesAction';
import { useBulkMarkAsFulfilledAction } from 'src/components/Sales/SalesActionDropdown/components/BulkMarkAsFulfilled';
import { useBulkUpdateAutoFulfillAction } from 'src/components/Sales/SalesActionDropdown/components/BulkUpdateAutoFulfillAction';
import { useBulkUpdateBarcodes } from 'src/components/Sales/SalesActionDropdown/components/BulkUpdateBarcodesAction';
import { Content } from 'src/contexts/ContentContext';
import { PosDropdown } from 'src/core/POS/PosDropdown';
import { vars } from 'src/core/themes';
import { Button } from 'src/core/ui';
import { ChevronDownIcon, IconsFill } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { EventWithData } from 'src/WebApiController';

interface FulfillmentActionsProps {
  event?: EventWithData['event'];
}

export const FulfillmentActions = ({ event }: FulfillmentActionsProps) => {
  const { areBulkActionsEnabled } = useBulkActionsState();
  const [isLoading, setIsLoading] = useState(false);
  const { filterQueryWithEventIds } = useSalesBulkActionsState();
  const bulkUpdateAutoFulfill = useBulkUpdateAutoFulfillAction(
    filterQueryWithEventIds,
    setIsLoading,
    isLoading,
    event
  );

  const bulkMarkAsFulfilled = useBulkMarkAsFulfilledAction(
    filterQueryWithEventIds,
    setIsLoading,
    isLoading,
    event
  );

  const bulkDeallocateSales = useBulkDeallocateCancelSalesAction(
    filterQueryWithEventIds,
    true, // Deallocate only
    setIsLoading,
    isLoading,
    event
  );

  const bulkRejectSales = useBulkDeallocateCancelSalesAction(
    filterQueryWithEventIds,
    false, // Deallocate only
    setIsLoading,
    isLoading,
    event
  );

  const bulkUpdateBarcodesAction = useBulkUpdateBarcodes(
    filterQueryWithEventIds,
    setIsLoading,
    isLoading,
    event
  );

  return (
    <>
      <PosDropdown
        key="sales-settings-actions-dropdown"
        trigger={
          <Button variant="outline">
            <Content id={ContentId.Fulfillment} />
            <ChevronDownIcon
              size={vars.iconSize.xs}
              fill={IconsFill.currentColor}
            />
          </Button>
        }
        align="start"
        triggerProps={{ disabled: isLoading || !areBulkActionsEnabled }}
      >
        {bulkUpdateAutoFulfill.dropDown}
        {bulkMarkAsFulfilled.dropDown}
        {bulkDeallocateSales.dropDown}
        {bulkRejectSales.dropDown}
        {event != null && bulkUpdateBarcodesAction.dropDown}
      </PosDropdown>
    </>
  );
};
